import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MissedGoalIncident',
  props: {
    rightSide: {
      type: Boolean
    },
    incident: null
  },
  setup(__props) {
    const props = __props;
    const iconClass = ref(props.incident.ownGoal ? 'text-red-600' : '');
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "text-ellipsis whitespace-nowrap overflow-hidden flex items-center",
        title: __props.incident.ownGoal ? _ctx.$t('own_goal') : 'goal'
      }, [__props.rightSide ? (_openBlock(), _createBlock(Icon, {
        key: 0,
        icon: _ctx.IconEnum.Futbol,
        class: _normalizeClass([iconClass.value, "mr-1 opacity-20"]),
        size: "1rem"
      }, null, 8, ["icon", "class"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.incident.player.shortName) + " ", 1), !__props.rightSide ? (_openBlock(), _createBlock(Icon, {
        key: 1,
        icon: _ctx.IconEnum.Futbol,
        class: _normalizeClass([iconClass.value, "ml-1 opacity-20"]),
        size: "1rem"
      }, null, 8, ["icon", "class"])) : _createCommentVNode("", true)], 8, _hoisted_1);
    };
  }
});